import { captureException } from '@sentry/browser';

export const ErrorCapture = (name: string, message: string, extra = {}): Error => {
  const e = new Error(message);
  e.name = name;
  captureException(e, { extra });
  return e;
};
